<template>
  <div v-if="passwordStrength > 0" class="strength-meter-bar">
    <div
      class="strength-meter-bar--fill"
      :style="{ width: passwordStrength + '%', 'background-color': calcProgressColor() }"
    ></div>
  </div>
</template>

<script>
export default {
  props: ["inputValue"],
  data() {
    return {
      passwordStrength: 0,
    };
  },
  watch: {
    inputValue(newVal) {
      if (newVal) {
        this.handlePasswordChange(newVal);
      } else {
        this.passwordStrength = 0;
      }
    },
  },
  methods: {
    handlePasswordChange(e) {
      const len = e.length;
      let percent1 = 0;
      let percent2 = 0;
      let percent3 = 0;

      if (len < 7) {
        percent1 = (len / 6) * 33.33;
      } else if (len < 15) {
        percent1 = 33.33; // 第一段已满
        percent2 = ((len - 6) / 8) * 33.33;
      } else {
        percent1 = 33.33; // 第一段已满
        percent2 = 33.33; // 第二段已满
        percent3 = ((len - 14) / 6) * 33.33;
      }

      this.passwordStrength = Math.min(percent1 + percent2 + percent3, 100);
      console.log(e, this.passwordStrength);
    },
    calcProgressColor() {
      return this.passwordStrength <= 33.33
        ? "#e74242"
        : this.passwordStrength <= 66.66
          ? "#efbd47"
          : "#55d187";
    },
  },
};
</script>

<style scoped>
.strength-meter-bar {
  width: inherit;
  position: relative;
  height: 6px;
  margin: 10px auto;
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.25);
}
.strength-meter-bar::before,
.strength-meter-bar::after {
  content: "";
  display: block;
  position: absolute;
  z-index: 10;
  height: inherit;
  border-width: 0 5px;
  border-style: solid;
  border-color: #fff;
  background-color: transparent;
}
.strength-meter-bar::before {
  left: 33.33%;
}
.strength-meter-bar::after {
  right: 33.33%;
}

.strength-meter-bar--fill {
  position: absolute;
  height: inherit;
  transition:
    width 0.5s ease-in-out,
    background 0.25s;
  border-radius: inherit;
  background-color: transparent;
}
</style>
